//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () { return { questions: [], idx: 0, picked: '', details: [], correct: 0, wrong: 0, start: Date.now() } },
  computed: { cur () { return this.questions[this.idx] } },
  created () {
    this.$ajax.get(this.$api.mpTestGenerate + '?palace_id=' + this.$route.query.id).then(r => {
      this.questions = (r && r.questions) || []
    })
  },
  methods: {
    next () {
      const result = 3 // 服务端按 user_input 重判
      this.details.push({ anchor_id: this.cur.id, word_id: this.cur.word_id, result, user_input: this.picked })
      this.$ajax.post(this.$api.mpReviewSubmit, { anchor_id: this.cur.id, result }).catch(() => {})
      this.picked = ''
      if (this.idx >= this.questions.length - 1) {
        this.$ajax.post(this.$api.mpTestSubmit, {
          palace_id: this.$route.query.id,
          duration: Math.round((Date.now() - this.start) / 1000),
          details: this.details
        }).then(r => {
          this.$router.replace({ path: '/mpResult_display', query: { record_id: r.record_id } })
        })
      } else this.idx++
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/memory-palace/test.vue